import React, { useEffect, useState } from 'react';

import styled from 'styled-components';
import { termsOfUse } from '../../constants/terms-of-use';

const TermsOfUsePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;

  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 18px;
  }
`;

const TermsOfUsePage = () => {
  const [tenantTerms, setTenantTerms] = useState();

  useEffect(() => {
    let terms = localStorage.getItem('terms-of-use');
    if (terms != null && terms.length != 0 && terms.trim()) {
      var newWindow = window.open(terms, '_blank');
      newWindow.location = terms;
      document.location.href = '/';
    }
  }, []);

  useEffect(() => {
    const getTerms = setInterval(() => {
      if (!tenantTerms) {
        const theme = localStorage.getItem('theme');

        setTenantTerms(termsOfUse[theme]);
      } else {
        clearInterval(getTerms);
      }
    }, 400);
  }, []);

  if (!tenantTerms) {
    return null;
  }

  return (
    <TermsOfUsePageWrapper>
      <h1>Termos de Uso e Privacidade - {tenantTerms.firstName}</h1>
      <p>
        {tenantTerms.fullName} (a “Empresa”), pessoa jurídica de direito privado inscrita no CNPJ sob o n. {tenantTerms.document}, com sede na {tenantTerms.address}, representada segundo os termos de seus documentos constitutivos.
        <br />
        <br />
        Obrigado por nos escolher!
        <br />
        <br />
        Por meio do nosso aplicativo (o “Software”), você (o “Usuário”) poderá controlar a recarga do seu veículo, encontrar a estação de recarga mais próxima, bem como controlar a estatística de uso,
        além de outras funções que você descobrirá ao utilizar o Software.
        <br />
        <br />
        Para isso, entretanto, é preciso que você leia integralmente este documento e concorde com ele. Caso você fique com alguma dúvida, entre em contato conosco! Se o aplicativo for utilizado,
        entenderemos que você leu e concordou com as disposições aqui contidas.
        <br />
        <br />
        Por isso, reforçamos a importância de uma leitura atenta e integral dos Termos e Condições de Uso.
        <br />
        <br />
        Sem prejuízo das demais disposições, as seguintes condições devem ser observadas:
        <br />
        <br />
        Os Termos de Uso são inteiramente publicizados, desta forma, não será considerado que seja alegado desconhecimento das regras e obrigações aqui estabelecidas.
        <br />
        <br />
        Estes Termos e Condições de Uso (“Termo(s)”) estabelecem os termos e condições aplicáveis à utilização dos serviços e da Plataforma. Ao utilizar os nossos serviços e/ou acessar a Plataforma, o
        Usuário assume e expressamente concorda com este Termo.
        <br />
        <br />
        Estes Termos de Serviços refletem a maneira como os nossos negócios funcionam, as leis que se aplicam à nossa empresa e determinados pontos em que sempre acreditamos. Como resultado, estes
        termos ajudam a definir nossa relação com você na medida da sua interação com os nossos serviços.
        <br />
        <br />
        Compreender estes termos é importante porque, para usar nossos serviços, você precisa aceitá-los.
        <br />
        <br />
        Além destes termos, também publicamos em nosso site uma Política de Privacidade. Embora ela não faça parte destes termos, recomendamos que você a leia para entender melhor como os dados são
        tratado
        <br />
        <br />
        1. DA PERMISSÃO DE USO
        <br />
        1.1 Ao utilizar nossos serviços e concordar com as disposições deste instrumento, a Empresa concederá uma permissão de uso do aplicativo, que permanecerá válida enquanto o Usuário cumprir suas
        responsabilidades definidas:
        <br />
        nestes termos;
        <br />
        política de privacidade.
        <br />
        <br />
        2. DO USO DO APLICATIVO
        <br />
        2.1 O acesso do Usuário aos serviços da Empresa se dará mediante condições estabelecidas entre as Partes, e o Usuário se obriga a manter e guardar as informações da relação sob sigilo.
        <br />
        2.2 O Usuário é inteiramente responsável (i) por manter sigilo de sua senha, e (ii) pela veracidade, exatidão, autenticidade e atualidade dos dados e informações fornecidos à Empresa, sendo
        responsável por quaisquer danos causados à Empresa ou a terceiros.
        <br />
        2.3 Se a Empresa constatar que as informações são de alguma forma incompletas, imprecisas, falsas ou desatualizadas, o Usuário poderá ter seu cadastro na Plataforma suspenso ou cancelado, a
        exclusivo critério da Empresa, sem prejuízos de outras medidas que sejam aplicáveis, caso em que não serão devidos quaisquer reembolsos.
        <br />
        <br />
        3. DOS DADOS PESSOAIS TRATADOS
        <br />
        3.1 A Empresa possui documento próprio, denominado Política de Privacidade, que regula o tratamento dos dados coletados por nós, sendo parte integrante e inseparável do presente Termo, e pode
        ser acessada em nosso site ou solicitada por meio dos nossos canais de comunicação.
        <br />
        3.1.1 Os Termos e a Política de Privacidade serão claros e transparentes e dispostos em local de fácil consulta pelos titulares de dados pessoais.
        <br />
        3.2 Caso alguma disposição sobre tratamento de dados pessoais da Política de Privacidade conflitar com qualquer outra do presente documento, deverá prevalecer o descrito nestes “Termos e
        condições de uso”.
        <br />
        3.3 Cabe à Empresa e seus Colaboradores, no limite das atividades de tratamento que efetivamente realizarem, atuar nos termos da legislação vigente e adotar as medidas técnicas, operacionais,
        organizativas e procedimentais de segurança aplicáveis a todo tempo durante o qual as atividades de tratamento perdurarem, que serão impostas aos terceiros que contratarem para desempenharem
        tais atividades, se aplicável.
        <br />
        3.4 Eventualmente, os dados pessoais do Usuário poderão ser fornecidos a terceiro, sendo tal fornecimento, contudo, realizado de forma anonimizada, a fim de que sejam utilizados os dados
        pessoais para estudos e pesquisas relativos ao perfil do consumidor no âmbito da eletromobilidade.
        <br />
        3.4.1 O uso dos dados pessoais por terceiros, de forma anonimizada, terá como finalidade, mas não se limitando a: i) (i) melhorar desempenho do Software junto ao Usuário; (ii) aumentar a
        acuracidade dos seus serviços e produtos, de modo a melhorar modelos e algoritmos subjacentes ao longo do tempo; (iii) realizar estudos e pesquisas internas.
        <br />
        3.5 Todos que, direta ou indiretamente, tenham relação com o tratamento de dados pessoais realizados no contexto de uso do Software devem envidar todos os esforços para que referido tratamento
        ocorra dentro do padrão normativo estabelecido pelas legislações aplicáveis.
        <br />
        3.6 As bases legais eventualmente utilizadas para o tratamento de dados pessoais são as listadas na Lei Geral de Proteção de Dados, conforme definido na Política de Privacidade.
        <br />
        3.7 Ao utilizar nossos serviços o Usuário concorda que a Empresa usará os dados pessoais para a finalidade especifica para a gestão e aperfeiçoamento dos serviços prestados, além das previstas
        na respectiva Política de Privacidade.
        <br />
        <br />
        4. DAS OBRIGAÇÕES E RESPONSABILIDADES DA EMPRESA
        <br />
        4.1 Os serviços da Empresa e suas funcionalidades são apresentadas ao Usuário na maneira como estão disponíveis, podendo passar por constantes aprimoramentos e atualizações, obrigando-se a
        Empresa a:
        <br />
        Preservar a sua funcionalidade, com links não quebrados e utilizando layout que respeita a usabilidade e navegabilidade, sempre que possível;
        <br />
        Exibir as funcionalidades e serviços de maneira clara, completa, precisa e suficiente de modo que exista a exata percepção das operações realizadas, e
        <br /> Proteger os dados pessoais coletados da maneira que julgar mais eficiente, sempre observando a legislação pertinente, além de informar o Usuário sobre eventuais disponibilização a
        terceiros, nos termos do presente instrumento.
        <br />
        <br />
        5. DAS OBRIGAÇÕES E RESPONSABILIDADES DO USUÁRIO
        <br />
        5.1 Os Usuários são responsáveis por e se obrigam a:
        <br />
        Utilizar com retidão e de forma ética os nossos serviços, respeitando as condições que regem a sua utilização e finalidade;
        <br />
        Fornecer informações e dados cadastrais precisos, verdadeiros, completos e atualizados, completos e atualizados, além de informar canal de contato apto a ser acionado para o melhor cumprimento
        dos serviços, responsabilizando-se civil e criminalmente por todas as informações fornecidas, comprometendo-se a atualizá-las sempre que houver alguma alteração por e-mail ou telefone;
        <br />
        Dispor de dispositivos e equipamentos compatíveis, serviço de conexão à Internet com antivírus e firewall habilitados, e softwares devidamente atualizados;
        <br />
        Deixar seus sistemas de antispam, filtros similares ou configurações de redirecionamento de mensagens ajustados de modo que não interfiram no recebimento dos comunicados e materiais da
        Empresa, não sendo aceitável nenhuma escusa caso não tenha tido acesso a algum e-mail ou mensagem eletrônica em virtude dos recursos mencionados;
        <br />
        Respeitar todos os direitos de propriedade intelectual de titularidade da Empresa ou de terceiros;
        <br />
        Não transmitir materiais contendo vírus de computador ou outros códigos, arquivos, scripts, agentes ou programas de computador maliciosos;
        <br />
        Não explorar maliciosamente os serviços para a prática de atos ilícitos, proibidos pela lei e pelo presente Termo, lesivos aos direitos e interesses da Empresa e de terceiros, ou que, de
        qualquer forma, possa danificar, inutilizar, sobrecarregar ou deteriorar os bens e serviços da Empresa;
        <br />
        Responsabilizar-se exclusivamente por qualquer dano por si causado à Empresa ou a terceiros em virtude do não cumprimento das obrigações aqui dispostas ou da não veracidade das informações
        prestadas, não havendo que se falar em subsidiariedade da obrigação, tampouco em solidariedade da Empresa.
        <br />O Usuário é o único e total responsável pelas informações inseridas ou repassadas por si para a Empresa, sendo certo que será o único responsável pelas sanções civis e penais que
        eventualmente resultarem de incorreção desses dados.
        <br />
        As funcionalidades que compõem o Software da Empresa não conferem ao Usuário nenhum direito sobre os direitos de propriedade intelectual do Software, seu conteúdo ou sobre as estruturas de
        informática que o sustentam.
        <br />O Usuário reconhece como de propriedade da Empresa o banco de dados em que serão armazenados e tratados os dados inseridos ou repassados à Empresa.
        <br />O Usuário se compromete a utilizar os serviços disponibilizados com boa-fé e em conformidade com todos os preceitos legais, regulamentares e contratuais porventura aplicáveis, com a
        ordem pública, as normas e padrões de conduta sociais e profissionais aceitas ou tidas como boas práticas.
        <br />
        <br />
        6. LIMITAÇÃO DA RESPONSABILIDADE
        <br />
        6.1 O Usuário reconhece que o uso inadequado e/ou a não observância da legislação poderá caracterizar a respectiva responsabilidade legal, seja no âmbito cível, seja no âmbito penal.
        <br />
        6.2 O Usuário expressamente reconhece que a Empresa não será responsável caso a impossibilidade ou comprometimento da boa utilização dos canais de comunicação sejam causadas por fato não
        atribuível a Empresa, o que inclui, mas não se limita a falha na infraestrutura de servidores externos, de telecomunicações e de energia, falha em equipamento essencial para o acesso à
        Plataforma ou ao software pelos Usuários, guerras, levantes, desastres naturais entre outros.
        <br />
        6.3 O Usuário expressamente reconhece que a Empresa, em nenhuma hipótese, será responsável por danos, perdas e danos, lucros cessantes e/ou danos emergentes decorrentes da utilização indevida
        do software ou da plataforma em relação a outros usuários e/ou terceiros e deverá ser mantida indene pelo Usuário.
        <br />
        6.4 Os únicos compromissos assumidos pela Empresa em relação ao Software, incluindo o conteúdo dele, as funções específicas ou a confiabilidade, disponibilidade ou possibilidade de atender às
        suas necessidades são (1) descritos no presente instrumento ou (2) determinados de acordo com as leis aplicáveis. Não assumimos nenhum outro compromisso adicional.
        <br />
        6.5 A menos que exigido por lei, não fornecemos garantias implícitas, como as garantias implícitas de comercialidade, adequação a uma finalidade específica e não violação.
        <br />
        6.6 Em nenhuma hipótese a Empresa se responsabilizará:
        <br />
        Por serviços prestados por parceiros ou terceiros disponíveis na Empresa, sendo o Usuário responsável por verificar e estar ciente de contratos, termos e condições do parceiro/terceiro para a
        contratação e uso do respectivo serviço, sendo a Empresa mera intermediadora dos serviços finais exercidos pelos parceiros/terceiros;
        <br />
        Pelas falhas de comunicação decorrentes de circunstâncias relacionadas à indisponibilidade da Internet em geral, quedas de energia, mau funcionamento digital ou físico de qualquer rede de
        telecomunicações, interrupções ou suspensões de conexão e falhas nos softwares e/ou hardwares utilizados pelos Usuários;
        <br />
        Por quaisquer problemas, bugs, glitches ou funcionamentos indevidos que ocorrerem nos dispositivos e equipamentos dos Usuários e sejam resultantes do uso regular;
        <br />
        Por erros de sistemas que alterem dados ou informações de serviços, inclusive preços informados pela Empresa, e por compras e pagamentos reprovados pelas instituições financeiras;
        <br />
        Por qualquer dano direto ou indireto ocasionado por eventos de terceiros, como ataque de hackers, falhas no sistema, no servidor ou na conexão à Internet, inclusive por ações de softwares
        maliciosos, como vírus, cavalos de Tróia e outros que possam, de algum modo, danificar o equipamento ou a conexão dos Usuário em decorrência do acesso, utilização ou navegação nos serviços da
        Empresa, bem como a transferência de dados e arquivos nela contidos, e
        <br />
        Pelas informações contidas nos cadastros feitos por meio dos canais de comunicação da Empresa, sendo certo que os dados constantes dos cadastros são de total responsabilidade dos respectivos
        Usuário, inclusive o de pessoas por ele adicionadas, os quais serão os únicos responsáveis pelas sanções civis e penais que eventualmente resultarem de incorreção nesses dados.
        <br />A Empresa somente solicita informações pessoais através dos canais oficiais. Nós não nos responsabilizamos por quaisquer comunicações eletrônicas fraudulentas que coletem dados pessoais
        de seus Usuários.
        <br />A Empresa pode, de acordo com seus objetivos de negócio, modificar, suspender ou descontinuar temporariamente as funcionalidades, serviços e/ou conteúdo prestado, segundo sua exclusiva
        conveniência, sempre que entender necessário para oferecer os melhores serviços ao Usuário.
        <br />A Empresa poderá, a qualquer tempo, alterar, adequar ou remodelar o conteúdo, layout, funcionalidades e/ou ferramentas relacionadas ao seu site, desde que esteja em conformidade com a
        legislação pertinente.
        <br />A Empresa pode, ainda, efetuar paralisações programadas para realizar a manutenção, atualização e ajustes de configuração dos seus serviços, visando a melhorias na qualidade dos serviços
        prestados aos seus Usuário, envidando seus melhores esforços para que os horários de manutenção não coincidam com horários comerciais nem de pico de acesso.
        <br />
        No entanto, caso haja manutenção emergencial a ser feita, esta poderá ocorrer dentro do horário comercial ou de pico, e sem aviso prévio, sendo que, nestes casos, a Empresa não será
        responsabilizada pela indisponibilidade por haver fundada justificativa para que a manutenção ocorresse dessa forma.
        <br />A Empresa não será responsável, sob quaisquer circunstâncias, por eventuais perdas e danos, incluindo lucros cessantes, relacionados à suspensão dos serviços. Os Usuários não possuem
        qualquer direito para exigir em relação à disponibilidade do site da Empresa, tampouco poderão pleitear indenização ou reparação de danos em caso dos canais de comunicação permanecerem fora do
        ar, independentemente da motivação.
        <br />A Empresa poderá, a seu exclusivo critério e sem qualquer obrigação, a qualquer tempo, com o intuito de minimizar riscos de falhas humanas e/ou uso indevido dos seus serviços,
        indisponibilizar, temporariamente, determinadas funcionalidades até que eventuais inconformidades sejam readequadas.
        <br />A Empresa poderá restringir, limitar ou impedir, por qualquer meio ou forma, o acesso de um ou mais Usuário aos seus serviços, conforme seu exclusivo critério, especialmente nos casos
        repetidos de suspeitas de fraude ou quaisquer outras ações que prejudiquem ou possam prejudicar o funcionamento da prestação de suas atividades.
        <br />A Empresa reserva a si o direito de, a qualquer momento e sem aviso prévio, suspender os serviços do Usuário que infringir qualquer das disposições aqui previstas, praticar, auxiliar ou
        instigar atos que venham a prejudicar o bom funcionamento dos serviços, ou vier a utilizar-se de atos ilícitos para ações relacionadas a relação com a Empresa, incluindo mas não se limitando
        a, inserção de dados falsos e/ou incorretos, a utilização de cartões fraudulentos ou inexistentes, dentre outros atos que venham a infringir qualquer disposição legal prevista no ordenamento
        jurídico.
        <br />
        <br />
        7. DA PROPRIEDADE INTELECTUAL‍
        <br />
        7.1 O uso comercial de qualquer propriedade intelectual sem consentimento expresso é proibido, aplicando-se, em eventual violação, as punições cabíveis, nos termos da legislação pertinente.
        <br />
        7.2 Usar qualquer propriedade intelectual de terceiro sem a prévia e expressa autorização poderá acarretar em responsabilizações penais, civis, administrativas e contratuais, conforme definido
        na legislação aplicável.
        <br />
        7.3 O presente Termo concede apenas uma permissão de uso, não valendo, para nenhum fim e efeito de Direito, como instrumento suficiente para a transmissão de qualquer direito sobre a
        propriedade intelectual.
        <br />
        <br />
        8. DA VIGÊNCIA
        <br />
        8.1 Este Termo entra em vigor na data de cadastro ou contato do Usuário em nossa plataforma e durará enquanto permanecer cadastrado ou pelo período enquanto houver necessidade de manter esses
        dados pessoais em nossos bancos de dados para as finalidades referidas nesses “Termos e Condições de Uso” e na nossa “Politica de Privacidade”.
        <br />
        8.2 Podemos atualizar estes termos e os termos adicionais específicos do serviço (1) para refletir mudanças nos nossos serviços ou na maneira como fazemos negócios, por exemplo, quando
        adicionamos serviços, recursos, tecnologias, preços ou benefícios novos (ou removemos os antigos), (2) por motivos jurídicos, regulatórios ou de segurança ou (3) para evitar abusos ou danos.
        <br />
        8.3 Se você não seguir estes termos ou a Política de Privacidade ou os contratos adicionais específicos do serviço, e não tomarmos as medidas cabíveis imediatamente, isso não significa que
        estamos desistindo de quaisquer direitos que possamos ter, como tomar as medidas cabíveis futuramente. ‍
        <br />
        <br />
        9. DA RESCISÃO
        <br />
        9.1 As Partes poderão rescindir o presente Termo, a qualquer tempo, ocorrendo, assim, o descadastramento do usuário, devendo ambas as Partes cumprirem com as obrigações assumidas até então.
        <br />
        9.2 A Empresa se reserva no direito de, sem a necessidade de notificação prévia, resolver de pleno direito o presente Termo, impedindo ou interrompendo os serviços no caso de (i) recuperação
        judicial ou extrajudicial, falência, liquidação judicial ou extrajudicial ou insolvência; (ii) violação ou não cumprimento, parcial ou total, de qualquer obrigação assumida nos termos deste
        Termo, de qualquer contrato celebrado por meio do Software ou da legislação aplicável; ou (iii) a Empresa, por motivos alheios a sua vontade, não possa prestar os serviços previstos neste
        Contrato, situação em que os valores efetivamente pagos durante o período no qual o Software passou a estar definitivamente indisponível serão restituídos, não podendo o Usuário, por sua vez,
        nada mais reclamar para todos os fins de direito.
        <br />
        9.3 Caso o cadastro do Usuário seja interrompido ou cancelado, todas as operações pendentes na Plataforma deverão ser concluídas com a totalidade dos pagamentos. ‍<br />
        <br />
        <br />
        10. DAS DISPOSIÇÕES GERAIS
        <br />
        10.1 A Empresa é uma empresa constituída no Brasil e o Software e os serviços são criados e mantidos em fiel cumprimento às leis brasileiras. Caso o Usuário esteja usufruindo do acesso da
        Plataforma fora do Brasil, o Usuário será responsável pelo cumprimento das leis locais, na medida em que forem aplicáveis.
        <br />
        10.2 Caso a Empresa deixe de exercer qualquer direito previsto neste Termo, isto não deverá ser interpretado como uma renúncia, abdicação ou revogação de disposição constante deste Termo.
        <br />
        10.3 Por lei, você tem certos direitos que não podem ser limitados por um contrato como estes Termos de Serviço. Estes termos não têm, de forma alguma, o objetivo de restringir esses direitos.
        <br />
        10.4 Estes termos descrevem a relação entre você e a Empresa. Eles não geram nenhum direito legal para outras pessoas ou organizações, mesmo que elas se beneficiem desse relacionamento sob
        estes termos.
        <br />
        10.5 Se um termo específico não for aplicável, isso não afetará os outros termos.
        <br />
        10.6 Se fizermos mudanças significativas nestes termos ou nos termos adicionais específicos do serviço, avisaremos com antecedência razoável e daremos a você oportunidade de analisar as
        mudanças, exceto (1) quando lançarmos um novo serviço ou recurso ou (2) em situações urgentes, como para evitar abusos atuais ou responder a requisitos legais. Se não concordar com os novos
        Termos, você deverá utilizar nossa plataforma.
        <br />
        <br />
        11. DAS NOTIFICAÇÕES
        <br />
        11.1 Em caso de esclarecimentos sobre o presente termo de uso o Usuário poderá entrar em contato conosco por meio dos contatos disponíveis em nosso site.
        <br />
        <br />
        12. DO FORO‍
        <br />
        12.1 Para dirimir quaisquer controvérsias é eleito o Foro da Cidade onde for a sede matriz da Empresa (conforme preâmbulo do presente instrumento).
        <br />
        Se você tem alguma dúvida sobre o Software, ou sobre este documento, entre em contato conosco por meio do seguinte e-mail: {tenantTerms.email}.
      </p>
    </TermsOfUsePageWrapper>
  );
};

export default TermsOfUsePage;
